var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64078 7.47075C8.70703 7.54184 8.74309 7.63587 8.74138 7.73303C8.73966 7.83019 8.70031 7.92288 8.63159 7.99159C8.56288 8.06031 8.47019 8.09966 8.37303 8.10138C8.27587 8.10309 8.18184 8.06703 8.11075 8.00078L6.61065 6.50069C6.5403 6.43042 6.50073 6.3351 6.50065 6.23567V3.23548C6.50065 3.13601 6.54016 3.04062 6.61049 2.97029C6.68082 2.89996 6.77621 2.86045 6.87567 2.86045C6.97513 2.86045 7.07052 2.89996 7.14085 2.97029C7.21118 3.04062 7.25069 3.13601 7.25069 3.23548V6.08066L8.64078 7.47075Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87632 1.73613C4.39466 1.73613 2.37603 3.75476 2.37603 6.23642C2.37603 8.71808 4.39466 10.7367 6.87632 10.7367C9.35798 10.7367 11.3766 8.71808 11.3766 6.23642C11.3766 3.75476 9.35798 1.73613 6.87632 1.73613ZM6.87632 11.4868C3.98113 11.4868 1.62598 9.13161 1.62598 6.23642C1.62598 3.34124 3.98113 0.986084 6.87632 0.986084C9.7715 0.986084 12.1267 3.34124 12.1267 6.23642C12.1267 9.13161 9.7715 11.4868 6.87632 11.4868Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchW);
export default __webpack_public_path__ + "static/media/watchW.07522c982c6c1f73510269c48d225aa6.svg";
export { ForwardRef as ReactComponent };